import React from 'react'
import { Link } from 'react-router-dom'
import { usePageHeaderStyles } from 'App/hooks/usePageHeaderStyles'
import { muiTheme as bannerTheme } from 'theme'
import { muiTheme as legacyTheme } from 'legacy-theme'
import { ThemeProvider } from '@material-ui/styles'
import cn from 'classnames'
import { PageHeaderButtons } from './PageHeaderButtons'

export interface PageHeaderProps {
  title: string
  subTitle?: string
  backLink?: string
  onBackClick?: () => void
  noPadding?: boolean
  bottomSpaceForHubspotWidget?: boolean
  isolateContentTheme?: boolean
  children: React.ReactNode
  error?: string
}

function PageHeaderComponent({
  title,
  subTitle,
  backLink,
  onBackClick,
  children,
  noPadding,
  bottomSpaceForHubspotWidget,
  isolateContentTheme,
  error,
}: PageHeaderProps) {
  const classes = usePageHeaderStyles()

  const renderSubTitle = () => {
    if (onBackClick) {
      return (
        <button type="button" className={classes.backLink} onClick={onBackClick}>
          {subTitle}
        </button>
      )
    }

    if (backLink) {
      return (
        <Link className={classes.backLink} to={backLink}>
          {subTitle}
        </Link>
      )
    }

    return <p className={classes.subTitle}>{subTitle || '\u00A0'}</p>
  }

  const content = error ? <p className={cn(classes.title, classes.error)}>{error}</p> : children

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <div className={classes.titles}>
          <h1 className={classes.title}>{title || ''}</h1>
          {renderSubTitle()}
        </div>
        <PageHeaderButtons />
      </div>
      <div
        className={cn(classes.childrenWrapper, {
          [classes.noPadding]: noPadding,
          [classes.bigBottomPadding]: bottomSpaceForHubspotWidget,
        })}
      >
        {isolateContentTheme ? <ThemeProvider theme={legacyTheme}>{content}</ThemeProvider> : content}
      </div>
    </div>
  )
}

export default function PageHeader(props: PageHeaderProps) {
  return (
    <ThemeProvider theme={bannerTheme}>
      <PageHeaderComponent {...props} />
    </ThemeProvider>
  )
}
